import { Button, Card, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/context/AuthContext';
import { useAllies } from '@/features/aliados/hooks/useAllies';
import { canWriteLocaciones } from '@/layouts/navigation';
import { LocationTable } from '../components/LocationTable';
import { useLocations } from '../hooks/useLocations';

/**
 * Tope de aliados traídos para el filtro/typeahead. El contrato de aliados no expone
 * un endpoint de "todos"; se piden los primeros 100. Si el catálogo crece, migrar el
 * filtro a búsqueda server-side por `q`.
 */
const ALLY_OPTIONS_LIMIT = 100;

/**
 * Listado de Locaciones (US-2.2, `/ubicaciones`) — paginación server-side vía
 * `useLocations`. La escritura es solo de `SUPER_ADMIN` (contrato): el botón de alta y
 * el CTA del empty-state se ocultan al resto de roles para no ofrecer un 403.
 */
export function LocationsListPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const locations = useLocations({ initialFilters: { status: 'ACTIVE' } });
  const allies = useAllies({ limit: ALLY_OPTIONS_LIMIT });

  const canCreate = canWriteLocaciones(user?.role);
  const openCreate = () => navigate('/ubicaciones/nueva');

  return (
    <div className="locaciones-page">
      <div className="locaciones-page__header">
        <Typography.Title level={3} style={{ margin: 0 }}>
          Ubicaciones
        </Typography.Title>
        {canCreate && (
          <Button type="primary" icon={<PlusOutlined />} onClick={openCreate}>
            Nueva ubicación
          </Button>
        )}
      </div>

      <Card>
        <LocationTable
          locations={locations.data}
          meta={locations.meta}
          loading={locations.loading}
          error={locations.error}
          filters={locations.filters}
          allies={allies.data}
          canCreate={canCreate}
          onFiltersChange={locations.setFilters}
          onOffsetChange={locations.setOffset}
          onRetry={locations.refresh}
          onCreate={openCreate}
          onSelect={(locationId) => navigate(`/ubicaciones/${encodeURIComponent(locationId)}`)}
        />
      </Card>
    </div>
  );
}
